
import { underLoadingFunction } from '@/store/helpers/under-loading'
import NewRegisterService from '@/services/new-register-service'
import * as MutationTypes from './mutation-types'

export default {
  state: {
    newUserData: {
      name: '',
      cpf: '',
      cel: '',
      email: '',
      password: ''
    },
    sentInfo: false,
    userValidated: false
  },
  mutations: {
    setNewUserData (state, payload) {
      state.newUserData.name = payload.name
      state.newUserData.cpf = payload.cpf
      state.newUserData.cel = payload.cel
      state.newUserData.email = payload.email
      state.newUserData.password = payload.password
    },
    validatedUser (state, userValidate) {
      state.userValidate = userValidate
    },

    [MutationTypes.SET_NEW_USER] (state, sentInfo) {
      state.sentInfo = sentInfo
    }
  },
  getters: {
    getNewUserData (state) {
      return state.newUserData
    }
  },
  actions: {
    setNewUserStateData ({ commit }, payload) {
      commit('setNewUserData', payload)
    },

    setNewUserAction: underLoadingFunction(async ({ commit }, paramns) => {
      await NewRegisterService.newRegister(
        paramns.userName,
        paramns.userCpf,
        paramns.userEmail,
        paramns.userCel,
        paramns.userPassword,
        paramns.emailConfirmation
      )
      commit(MutationTypes.SET_NEW_USER, true)
    }),

    validateRegisterAction: underLoadingFunction(async ({ commit }, code) => {
      await NewRegisterService.validateRegister(code)
      commit('validatedUser', true)
    })

  }
}
